import {
  configureStore, createSagaMiddleware, sessionStorage, persistReducer, encryptTransform,
} from 'lib/redux';
import { getAuthToken } from 'utils/auth.utils';
import rootReducer from './RootReducer';
import rootSaga from './RootSaga';

const devMode = process.env.NODE_ENV === 'development';
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: 'myev',
  storage: sessionStorage,
  blacklist: ['userData', 'notificationBar', 'nonPersisted', 'analyticsDashboard'],
  transforms: [
    encryptTransform({
      secretKey: getAuthToken() || ' ',
      onError() { },
    }),
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default (preloadedState) => {
  const store = configureStore({
    reducer: persistedReducer,
    devTools: devMode,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
    }).concat(sagaMiddleware),
    preloadedState,
  });
  sagaMiddleware.run(rootSaga);

  return store;
};
